// testimonials.ts — Patch 014.4. Client testimonial lifecycle methods.
//
// See workers/core-os/src/routes/testimonials.ts.

import { request } from './request'
import type {
  CreateTestimonialInput,
  PatchTestimonialInput,
  TestimonialListResponse,
} from './types'

export const testimonialsApi = {
  list: (params?: { status?: string; profile_id?: string }) => {
    const qs = new URLSearchParams()
    if (params?.status) qs.set('status', params.status)
    if (params?.profile_id) qs.set('profile_id', params.profile_id)
    const suffix = qs.toString() ? `?${qs.toString()}` : ''
    return request<TestimonialListResponse>(`/api/testimonials${suffix}`)
  },
  create: (body: CreateTestimonialInput) =>
    request<{ ok: true; id: string; status: string; request_id: string }>(
      '/api/testimonials',
      { method: 'POST', body: JSON.stringify(body) },
    ),
  update: (id: string, body: PatchTestimonialInput) =>
    request<{ ok: true; id: string; updated: string[] }>(
      `/api/testimonials/${encodeURIComponent(id)}`,
      { method: 'PATCH', body: JSON.stringify(body) },
    ),
}
